import { DataBean } from "../DataBean";


export class TaxableBase extends DataBean {

    public async getTaxableAmountForHoldingTax(idUBLInvoice: number, issueDate: any, adquisitionArticleType: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxableAmountForHoldingTax_Number_java.util.Date_Number", [idUBLInvoice, issueDate, adquisitionArticleType]);
    }

    public async getUBLItemsInvoiceValuesByBudget(idUBLInvoice: number, issueDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLItemsInvoiceValuesByBudget_Number_java.util.Date", [idUBLInvoice, issueDate]);
    }

}